import { ReactNode } from 'react';
import { MenuMobile } from 'components';

type Props = {
  onClose: () => void;
  children: ReactNode;
};

export const DropDownMobileMenu = ({ onClose, children }: Props) => {
  return <MenuMobile onClose={onClose}>{children}</MenuMobile>;
};
